import { z } from 'zod'
import { makeFieldKeys } from '../../core/utils/utilities.ts'

export const ModulesModelSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    key: z.string()
  })
  .strict()

const ModulesModelFields = makeFieldKeys(ModulesModelSchema)

type ModulesModel = z.infer<typeof ModulesModelSchema>
